import { Button, Grid, Typography } from '@material-ui/core';
import React from 'react';
import { useTranslate } from 'react-admin';
import FormUpdate from './FormUpdate';
import GoBackButton from '../CustomizedUIs/GoBackButton';
import { FormUpdateProps } from '../types';

const EditAndCreateExternalDevice = ({ itemRow, onGoBack, roomID }: FormUpdateProps) => {
    const translate = useTranslate();

    return (
        <Grid container xs={10}>
            <Grid
                item
                alignContent='center' >
                <Button
                    onClick={onGoBack}
                    startIcon={<GoBackButton color={undefined} />}
                    style={{ textTransform: 'capitalize' }}
                    color='inherit'
                >
                    {translate(`pos.externalDevice.back`)}
                </Button>
            </Grid>
            <Grid
                container
                item
                justifyContent='center'
                alignItems='center'
            >
                <Grid
                    item
                    xs={12}
                >
                    <Typography
                        style={{ fontFamily: 'UniviaPro-Medium', fontWeight: 'normal', color: '#4f5064' }}
                        variant='h5'
                    >
                        {itemRow ? translate(`pos.externalDevice.edit`) : translate(`pos.externalDevice.add`)}
                    </Typography>
                </Grid>
                <Grid
                    item
                >
                    <FormUpdate itemRow={itemRow ? itemRow : undefined} roomID={roomID} onGoBack={onGoBack} />
                </Grid>
            </Grid>
        </Grid>
    );
}

export default EditAndCreateExternalDevice;
